import { Injectable, inject } from '@angular/core';
import {
  ToolingTaskSettings,
  ToolingTaskSettingsApi,
  toolingTaskSettingsDefaults,
  toolingTaskColumnsBaseConfig,
} from './tooling-task-settings.api';
import { SettingsServiceBase } from 'src/services';
import { ToolingTask } from './tooling-tasks.model';
import { configToSettingsColumnTitles } from '../config-utils';

@Injectable()
export class ToolingTaskSettingsService extends SettingsServiceBase<
  keyof ToolingTask,
  ToolingTaskSettings,
  ToolingTaskSettingsApi
> {
  constructor() {
    const settingsApi = inject(ToolingTaskSettingsApi);

    super(
      settingsApi,
      configToSettingsColumnTitles(toolingTaskColumnsBaseConfig),
      toolingTaskSettingsDefaults
    );
  }
}
